import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux'
import { compose } from 'recompose';

import { withStyles, Typography, Card, CardContent, CardMedia, Avatar } from '@material-ui/core';
import parseImagUrl from "../../../../components/Common/parseImagUrl";

import { goToCollection } from "../../../../../actions/goToActions";
import { withTranslation } from 'react-i18next'
import { allCollectionMembers, isUserMember } from '../../../groups/groupUtils.js';
import GeneralButton from '../../../../components/Common/AllButton/AllButton';
import groupPlaceholder from "../../../../../assets/img/group_placeholder.png";

const BIG_CARD_WIDTH = 512
const SMALL_CARD_WIDTH = 248
const CARD_IMAGE_HEIGHT = 364
const CONTENT_HEIGHT = 134

// Apply some reset
const styles = theme => ({
    container2: {
        marginBottom: 10,
        "position": "relative",
        border: `1px solid ${theme.customColors.primary.b200}`,
        marginRight: 10,
        transition: theme.transitions.create('width'),
        width: SMALL_CARD_WIDTH,
        height: 546,
        borderRadius: 4,
        overflow: 'hidden',
        '&:last-child': {
            marginRight: 0
        },
        boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.25), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14)'
    },
    
    img2: {
        width: '100%',
        height: CARD_IMAGE_HEIGHT,
    },
    content2: {
        paddingTop: 24,
        paddingBottom: 24,
        paddingRight: 20,
        paddingLeft: 20,
        height: CONTENT_HEIGHT,
        backgroundColor: theme.customColors.primary.b350,
    },
    name2: {
        cursor: 'pointer',
        color: 'rgba(255,255,255,1)',
        textAlign: 'center',
        fontStyle: 'normal',
        fontFamily: 'Rubik',
        fontWeight: 'normal',
        lineHeight: 'normal',
        fontStretch: 'normal',
        letterSpacing: 'normal',
        fontSize: 24,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: 'nowrap',
        '&:hover': {
            textDecoration: 'underline',
            textDecorationColor: 'rgba(255,255,255,1)'
        },
    },
    numOfFollowers: {
        color: 'rgba(255,255,255,0.7)',
        fontStyle: 'normal',
        fontFamily: 'Rubik',
        fontWeight: 'normal',
        lineHeight: 1.5,
        fontStretch: 'normal',
        letterSpacing: 'normal',
        fontSize: 16,
    },
    avatar: {
        border: `solid 2px ${theme.customColors.primary.b350}`,
        width: 24,
        height: 24,
        marginLeft: -12
    },
    moreAvatars: {
        zIndex: 1,
        width: 24,
        height: 24,
        background: '#fff',
        borderRadius: '50%',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        marginLeft: -12,
        color: '#7d3deb',
        border: `solid 2px ${theme.customColors.primary.b350}`,
        fontWeight: '500',
        fontSize: 11,
        fontStyle: 'normal',
        fontFamily: 'Rubik',
        lineHeight: 'normal',
        fontStretch: 'normal',
        letterSpacing: 'normal',
    },
    bottomContent: {position: 'absolute', bottom: 24, left: 20, right: 20, marginRight: 'auto', marginLeft: 'auto', display: 'flex', flexDirection: 'row'},
    itemsContent: {display: 'flex', flexDirection: 'row', marginTop: 16},
    collectionItems: {display: 'flex', flexDirection: 'column'},
    collectionFaces: { display: 'flex', marginRight: 0, marginLeft: 'auto' },
    subsribeButtomContainer: {
        width: 130,
        height: 38,
        backgroundColor: 'transparent',
        border: 'solid 2px #e0e0e0',
        color: '#fff',
        '&:hover': {
            background: '#FFF',
            color: '#21212d',
        },
    },
    subsribeButtomText: {
        marginTop: 2,
        fontSize: 14,
        lineHeight: 2,
        letterSpacing: 1.5,

    },
    unsubsribeButtomContainer: {
        width: 130,
        height: 38,
        backgroundColor: '#fff',
        border: 'solid 2px #fff',
        color: '#21212d',
        '&:hover': {
            background: 'transparent',
            color: '#fff',
        },
    }
});


const CollectionsCard = (props) => {
    const { classes, collection, maxUsersLength, cloudfront, t, dispatch, profileData, join, view } = props;
    const [cardWidth, setCardWidth] = useState(SMALL_CARD_WIDTH)
    const [members, setMembers] = useState([])
    const [backgroundLink] = useState(parseImagUrl(cloudfront, collection.backgroundUrl, 500, groupPlaceholder))
    const canLeaveTheGroup = isUserMember(members, profileData.auth0_id)

    const openCollectionView = () => {
        goToCollection('/' + collection.title, dispatch, collection.collectionUid, collection.collectionGroup.groupUid)();
    }
    const usersLength = members.length

    useEffect(() => {
        setCardWidth(usersLength >= maxUsersLength /2 ? BIG_CARD_WIDTH : SMALL_CARD_WIDTH)
    }, [maxUsersLength, usersLength])

    useEffect(() => {
        const members = allCollectionMembers(collection)
        setMembers(members)
    }, [collection])


    const renderCollectionFaces = () => {
        return <div data-intrcm-id="CollectionsCard_gl6z78jd" className={classes.collectionFaces}>
            {members.slice(0, 3).map((tagedUser, idx) => {
                return <Avatar key={idx} alt={tagedUser.fullName} src={parseImagUrl(cloudfront, tagedUser.profileImageUrl)} className={classes.avatar} />
            })}
            {members.length - 3 > 0 && <div data-intrcm-id="CollectionsCard_n8k3mm6b" className={classes.moreAvatars}>{`+${members.length - 3}`}</div>}
        </div>
    }

    const renderCollectionItems = () => (
        <div data-intrcm-id="CollectionsCard_xd17u0eh" className={classes.collectionItems}>
            <Typography className={classes.numOfFollowers}>
                {allCollectionMembers(collection).length} {t('Items')}
            </Typography>
        </div>
    )

    const onClickGeneral = () => {
        canLeaveTheGroup ? openCollectionView() : join(collection, openCollectionView)
    }

    const renderSubscribeButton = () => {
        const title = canLeaveTheGroup ? t('VIEW') : t('JOIN')
        const containerStyle = canLeaveTheGroup ? classes.unsubsribeButtomContainer : classes.subsribeButtomContainer
        return <GeneralButton onClick={onClickGeneral} containerStyle={containerStyle} textStyle={classes.subsribeButtomText} title={title} />
    }


        return (
            <Card style={{minWidth: cardWidth}} className={classes.container2} elevation={0}>
                <CardMedia className={classes.img2}
                    image={backgroundLink}
                    title={collection.title} />
                <CardContent className={classes.content2}>
                    <Typography onClick={openCollectionView} className={classes.name2}>{collection.title}</Typography>
                    <div data-intrcm-id="CollectionsCard_odm4m31s" className={classes.itemsContent}>
                        {renderCollectionItems()}
                        {renderCollectionFaces()}
                    </div>
                    <div data-intrcm-id="CollectionsCard_6my15rkl" className={classes.bottomContent}>
                        {renderSubscribeButton()}
                    </div>

                </CardContent>
            </Card>
        )
}

const mapStateToProps = (state) => ({
    profileData: state.userData.profileData,
    cloudfront: state.globalData.cloudfront,
})


const mapDispatchToProps = dispatch => ({ dispatch })

export default compose(withStyles(styles, {withTheme: true}), withTranslation('library'),
    connect(mapStateToProps, mapDispatchToProps))(CollectionsCard);
